import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Paper, Typography } from '@mui/material';

import { AudioFileSVG, DocFileSVG, VideoFileSVG } from '@components/icon/svg';
import { getFileTypeDisplay } from './getFileTypeDisplay';

const UploadedFiles = ({ files, onRemoveFile, width }) => {
  if (files.length === 0) return null;

  return (
    <Box
      sx={{
        background: 'white',
        p: 2,
        maxHeight: 224,
        display: 'flex',
        flexDirection: 'column',
        width: { xs: '90%', sm: '90%', md: width },
        mx: 'auto',
        mt: 1,
        border: '2px solid #E8E8E8',
        borderRadius: '12px',
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          fontSize: { xs: '0.75rem', sm: '0.875rem' },
          fontWeight: 500,
          mb: '2px',
        }}
      >
        Uploaded Files ({files.length} selected)
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          fontSize: { xs: '0.75rem', sm: '0.875rem' },
          fontWeight: 400,
          mb: 1,
        }}
      >
        You can always add more files later within the study.
      </Typography>
      <Box
        sx={{
          flex: 1,
          overflowY: 'auto',
          '&::-webkit-scrollbar': {
            width: '0.5vw',
          },
          '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
            borderRadius: '0.2vw',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '0.2vw',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: '#555',
          },
        }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
            gap: 1,
          }}
        >
          {files.map((file) => (
            <Paper
              key={file.id}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                p: 0.5,
                border: '1px solid #C9B7FF',
                bgcolor: '#f8f7ff',
                borderRadius: 1.5,
                position: 'relative',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {/* <FileText size={20} /> */}
                {file.type.split('/')[0] === 'audio' ? (
                  <AudioFileSVG />
                ) : file.type.split('/')[0] === 'video' ? (
                  <VideoFileSVG />
                ) : (
                  <DocFileSVG />
                )}
                <Box>
                  <Typography
                    sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      maxWidth: '150px',
                    }}
                    variant="body2"
                  >
                    {file.name}
                  </Typography>
                  <Typography
                    sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      maxWidth: '150px',
                    }}
                    variant="caption"
                    color="text.secondary"
                  >
                    {getFileTypeDisplay(file.type)} • {(file.size / 1024).toFixed(0)} KB
                  </Typography>
                </Box>
              </Box>
              <IconButton
                size="small"
                onClick={() => onRemoveFile(file.id)}
                sx={{
                  color: 'grey.500',
                  position: 'absolute',
                  right: 8,
                  top: '50%',
                  transform: 'translateY(-85%)',
                }}
              >
                <CloseIcon size={16} />
              </IconButton>
            </Paper>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default UploadedFiles;
